/**
 * <dbr-footer> — reveal sutil (fade + slide-up, stagger por coluna) ao
 * entrar na viewport. Sem parallax: a seção não tem imagem de fundo, o
 * "fixed background" da classe .gradient já dá o respiro de profundidade.
 */
class DbrFooter extends HTMLElement {
  connectedCallback() {
    this.revealEls = this.querySelectorAll('.dbr-footer__reveal');

    if (window.DbrAnim && window.DbrAnim.reducedMotion) {
      this.setFinalState();
      return;
    }

    if (window.DbrAnim) {
      window.DbrAnim.ready(this.setup.bind(this));
    } else {
      this.setFinalState();
    }
  }

  setup(gsap) {
    if (!this.revealEls.length) return;

    var tween = gsap.fromTo(
      this.revealEls,
      { autoAlpha: 0, y: 24 },
      {
        autoAlpha: 1,
        y: 0,
        duration: 0.7,
        ease: 'power2.out',
        stagger: 0.12,
        scrollTrigger: { trigger: this, start: 'top 85%' },
      }
    );
    this.scrollTrigger = tween.scrollTrigger;
  }

  setFinalState() {
    this.revealEls.forEach(function (el) {
      el.style.opacity = '1';
      el.style.transform = 'none';
    });
  }

  disconnectedCallback() {
    if (this.scrollTrigger) this.scrollTrigger.kill();
  }
}

if (!customElements.get('dbr-footer')) {
  customElements.define('dbr-footer', DbrFooter);
}
